import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Tag } from 'lucide-react';
import { PROMO_BANNER } from '../../data/mockPortalData';

export function PromoBanner() {
  const [visible, setVisible] = useState(true);

  if (!PROMO_BANNER.active) return null;
  if (!visible) return null;

  return (
    <div className="bg-[hsl(214,58%,41%)] text-white no-print" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-10 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Tag className="w-3.5 h-3.5 text-amber-400 flex-shrink-0" />
          <span className="text-xs sm:text-sm font-medium truncate">{PROMO_BANNER.text}</span>
          {PROMO_BANNER.code && (
            <span className="hidden sm:inline text-[10px] px-2 py-0.5 rounded bg-white/20 font-mono font-bold">
              {PROMO_BANNER.code}
            </span>
          )}
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link to={PROMO_BANNER.link} className="h-6 px-3 rounded-md bg-amber-500 text-[10px] font-bold text-black flex items-center hover:bg-amber-400 transition-colors">
            {PROMO_BANNER.cta}
          </Link>
          <button onClick={() => setVisible(false)} className="w-5 h-5 rounded flex items-center justify-center hover:bg-white/10 transition-colors">
            <X className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
}
